export const TOPIC_NEW_INSURANCE_POLICY = 'NewInsurancePolicy'
export const TOPIC_RENEWAL_AVAILABLE = 'RenewalAvailable'
export const TOPIC_READY_PROPOSAL = 'ReadyProposal'
